















import { Component, Vue, Watch } from 'vue-property-decorator';
import { MessagingReportsData, messagingReportsApi } from '@/features/reports/services/messagingReportsApi';
import ContactTrendCharts from '@/features/reports/components/conversations/ContactTrendCharts.vue';
import ConversationTrendCharts from '@/features/reports/components/conversations/ConversationTrendCharts.vue';
import { Getter, Mutation } from 'vuex-class';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { DateOption } from '../models';
import { SET_REPORT_LOADING } from '@/store/reports/mutationTypes';

@Component({
	mixins: [],
	components: {
		ConversationTrendCharts,
		ContactTrendCharts,
	},
})
export default class MessagingReports extends Vue {
	@Getter public currentWorkspace!: WorkspaceViewModel;
	@Getter public selectedDateOption!: DateOption;

	@Mutation(SET_REPORT_LOADING) public setLoading: (loading: boolean) => void;

	public data: MessagingReportsData | { newContactsTrendReport: null; newConversationsTrendReport: null } = {
		newContactsTrendReport: null,
		newConversationsTrendReport: null,
	};

	public loadingError: boolean = false;
	public loadedData: boolean = false;

	@Watch('selectedDateOption', { immediate: true })
	public async onFilterChange(filter: DateOption, previous: DateOption) {
		if (filter && filter === previous) {
			return;
		}

		await this.loadData();
	}

	private async loadData() {
		this.loadedData = false;
		this.loadingError = false;
		this.setLoading(true);
		try {
			this.data = await messagingReportsApi.loadReportData(this.currentWorkspace.id, {
				startDate: this.selectedDateOption.getDateRange().start,
				endDate: this.selectedDateOption.getDateRange().end,
				grouping: this.selectedDateOption.group,
			});
			this.loadedData = true;
		} catch {
			this.loadingError = true;
		} finally {
			this.setLoading(false);
		}
	}
}
